module.exports = __webpack_public_path__ + "static/kaczan2-82a3ab96a8896823b1410118161df986.jpg";